import { Base, CoinsIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

interface RefundBadgeProps {
  isRefunded: boolean
}

export const RefundBadge: React.FC<RefundBadgeProps> = ({ isRefunded }) => {
  const { t } = useTranslation()
  return (
    <Base.Badge tone={isRefunded ? 'success' : 'warning'} icon={<CoinsIcon />}>
      {isRefunded
        ? t('process_details_page.refunded')
        : t('process_details_page.pending_refund')}
    </Base.Badge>
  )
}
